import styled from "styled-components";
import { styleSystem } from "../../toolkit/styleSystem";

const Wrapper = styled.span`
  line-height: 0;
  color: ${(p) => p.theme.colors.secondary[1]} ${styleSystem()};
`;

const ListItemIcon = ({children, ...props }) => {
  return (
    <Wrapper {...props}>
      {children}
    </Wrapper>
  );
};

export default ListItemIcon;
